import { Component, inject, Signal, signal } from '@angular/core';
import { form, FormField, required, submit } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { ActiveProjectService } from '@app/shared/services/active-project.service';
import { LocationsDataService } from '@app/shared/services/locations-data.service';
import { AddProjectLocationDialogData, LocationNameFormModel } from '@app/shared/types/models/location/location.model';
import { Project } from '@app/shared/types/models/project/project.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'proffeo-add-sublocation-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, FormField, UiInputComponent, UiButtonComponent],
  templateUrl: './add-sublocation-dialog.component.html'
})
export class AddSublocationDialogComponent {
  private readonly activeProjectService: ActiveProjectService = inject(ActiveProjectService);
  private readonly locationService: LocationsDataService = inject(LocationsDataService);
  private readonly dialogRef: MatDialogRef<AddSublocationDialogComponent> = inject(
    MatDialogRef<AddSublocationDialogComponent>
  );
  private readonly dialogData: AddProjectLocationDialogData = inject(MAT_DIALOG_DATA);

  protected readonly selectedProject: Signal<Project> = this.activeProjectService.activeProject;
  protected readonly model = signal<LocationNameFormModel>({ name: '' });
  protected readonly form = form(this.model, path => {
    required(path.name);
  });

  public save(): void {
    void submit(this.form, {
      action: async () => {
        try {
          await firstValueFrom(
            this.locationService.addLocation(this.selectedProject()?.id, this.model().name, 0, this.dialogData.parentId)
          );
          this.dialogRef.close();
        } catch {
          // HTTP errors are reported globally; the dialog stays open for a retry.
        }
      }
    });
  }
}
